import { render, staticRenderFns } from "./SLPayroll.vue?vue&type=template&id=30ad9210&scoped=true&"
import script from "./SLPayroll.vue?vue&type=script&lang=js&"
export * from "./SLPayroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ad9210",
  null
  
)

export default component.exports